"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9733],{

/***/ 9733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CityPWA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4250);
/* eslint-disable react/no-danger */ 


function CityPWA(props) {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.body.classList.add("bodyClass");
        document.body.id = "cmsintlflt";
        document.body.setAttribute("data-domain", "www_intl_flight_makemytrip_com");
    });
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, blocksData = ref.blocksData, pageData = ref.pageData, isIntl = ref.isIntl, templateType = ref.template_type, ccde = ref.ccde, lang = ref.lang, appConfig = ref.appConfig, tmp = ref.heading_and_searchbar, headingAndSearchBar = tmp === void 0 ? "" : tmp, preLoadedState = ref.preLoadedState, jsSettingJson = ref.jsSettingJson, tokenJson = ref.tokenJson, intid = ref.intid, region = ref.region;
    var cssPath;
    var jsPath;
    // let imagePath;
    // let minExt;
    var bankOfferPath;
    var intentOfferPath;
    var seoListingPath;
    var staticWidgetPath;
    var webVitalsPath;
    if (appConfig && appConfig.liveMode) {
        cssPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css";
        jsPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js";
        // imagePath = `${appConfig.imagePath}/images`;
        // minExt = '.min';
        intentOfferPath = "".concat(jsPath, "/intentOffer.min.js");
        seoListingPath = "".concat(cssPath, "/seoListingMob.min.css");
        bankOfferPath = "".concat(cssPath, "/bankOfferMob.min.css");
        staticWidgetPath = lang === "hin" ? "".concat(jsPath, "/hiStaticSeoWidgetMob.min.js") : "".concat(jsPath, "/staticSeoWidgetMob.min.js");
        webVitalsPath = "".concat(jsPath, "/webVitalsScript.min.js");
    } else {
        cssPath = "http://localhost:3000/_next/static/css";
        jsPath = "http://localhost:3000/_next/static/js";
        // imagePath = '/images';
        // minExt = '';
        intentOfferPath = "".concat(jsPath, "/intentOffer.min.js");
        seoListingPath = "".concat(cssPath, "/seoListingMob.min.css");
        bankOfferPath = "".concat(cssPath, "/bankOfferMob.min.css");
        staticWidgetPath = lang === "hin" ? "".concat(jsPath, "/hiStaticSeoWidgetMob.min.js") : "".concat(jsPath, "/staticSeoWidgetMob.min.js");
        webVitalsPath = "".concat(jsPath, "/webVitalsScript.min.js");
    }
    var tokenJsonString = tokenJson && tokenJson.length !== 0 ? "var tokenJson = ".concat(JSON.stringify(tokenJson)) : 'var tokenJson = {"prefilledDestCity":{"country":"India","iata":"BOM","city":"Mumbai, India","value":"Mumbai (BOM)"},"tokensList":{},"prefilledSrcCity":{"country":"India","iata":"DEL","city":"New Delhi, India","value":"New Delhi (DEL)"}};';
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var middleBlockHtml = "".concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentTop) ? blocksData.contentTop : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentMiddle) ? blocksData.contentMiddle : "").concat((pageData === null || pageData === void 0 ? void 0 : pageData.content) ? pageData.content : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentBottom) ? blocksData.contentBottom : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.bottomBlock) ? blocksData.bottomBlock : "");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var buttons = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(".listing-card-wrpr");
        if (buttons) {
            buttons === null || buttons === void 0 ? void 0 : buttons.forEach(function(button) {
                var url = button.getAttribute("data-url");
                if (url) {
                    button.onclick = function() {
                        return window.location.replace(url);
                    };
                }
            });
        }
    }, [
        middleBlockHtml
    ]);
    // Before passing, make sure the string has data-url instead of onclick
    var sanitizedHtml = middleBlockHtml.replace(/onclick="[^"]*"/, "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n      window.__PRELOADED_STATE__ = '".concat(preLoadedState, "';\n      window.showLeaveIntent = true;\n      var mbox_id = 'New_homepage_Hero', top_mbox_id = 'HPLP_Topbar_New', dealsPerLoad = '12', dealMaxLoad = '48', voyagerURL = '//voyager.goibibo.com/api/v1/flights_search/find_node_by_name_v2/?limit=15&amp;country_filter_id=5597365951189135149', voyagerTimeout = '3000';\n      var jsSettingJson = ").concat(JSON.stringify(jsSettingJson), ";\n      ").concat((appConfig === null || appConfig === void 0 ? void 0 : appConfig.settings) ? "var flightsettings = ".concat(JSON.stringify(appConfig.settings), ";") : "", ";\n      ").concat(tokenJsonString, '\n      var intid = "').concat(intid || "", "\";\n      var mmt = {};\n      mmt.hlp = {};\n      var device = 'desktop';\n      window.isIntl = ").concat(isIntl || false, ";\n      var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = new Date(), serverTime = new Date(), noOfDaysToAddInDept = tokenJson?.noOfDaysToAddInDept, noOfDaysToAddInReturn = tokenJson?.noOfDaysToAddInReturn;\n      var template = '").concat(templateType, "';\n      window.template = '").concat(templateType, "';\n      let ccdeVal = '").concat(region ? "&ccde=".concat(region) : "&ccde=IN", "';\n      ")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(staticWidgetPath)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                defer: true,
                type: "module",
                src: "".concat(webVitalsPath)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "text/javascript",
                children: "window.FLTS = {};\n        window.FLTS.listingStartTime = Date.now();"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: ".modify-search-header {position: relative;}"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                dangerouslySetInnerHTML: {
                    __html: "".concat(headingAndSearchBar)
                },
                class: "modify-search-header",
                id: "orderHeader"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(intentOfferPath)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "".concat(seoListingPath),
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "".concat(bankOfferPath),
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fli-intl-container prepend_top20 clearfix listingContainer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "makeCenterCol clearfix noPadding",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "seoContentMiddle",
                            className: "seoOnlyBlock col-lg-9 col-md-12 col-sm-12 col-xs-12 paddL0 airline-left-container nopadding-mob paddR0 ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: containerRef,
                                children: (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(sanitizedHtml)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            id: "seoRightBlock",
                            className: "seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 ",
                            children: [
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(blocksData === null || blocksData === void 0 ? void 0 : blocksData.filterBlock),
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(blocksData === null || blocksData === void 0 ? void 0 : blocksData.rightBlock),
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(blocksData === null || blocksData === void 0 ? void 0 : blocksData.leftBlock)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: blocksData === null || blocksData === void 0 ? void 0 : blocksData.top_overlay
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: '$(document).ready(function(){$(".viewFareBtn").click(function(e){e.preventDefault();$(this);let t=document.getElementsByClassName("hideCheapCards"),n=document.getElementById("viewFareBtn");if(n.parentNode.removeChild(n),t.length>0)for(var a=0;a<=t.length;a++)t[a]&&t[a].classList.remove("hideCheapCards")})});'
                }
            })
        ]
    });
}


/***/ })

}]);